export * from './confirm-modal';
export { confirmModalI18n } from './confirm-modal.i18n';